export const translations = {
  fr: {
    // Navigation
    'nav.features': 'Accueil',
    'nav.shop': 'Boutique',
    'nav.pricing': 'Tarifs',
    'nav.howItWorks': 'Comment ça marche',
    'nav.faq': 'FAQ',
    'nav.affiliate': 'Affiliation',
    'nav.login': 'Connexion',
    'nav.signup': 'Créer un compte',
    'nav.myAccount': 'Mon Compte',
    'nav.mainLabel': 'Navigation principale',
    'nav.skipToContent': 'Aller au contenu',
    'nav.openMenu': 'Ouvrir le menu',
    'nav.closeMenu': 'Fermer le menu',

    // Hero Section
    'hero.title1': 'Transformez votre',
    'hero.title2': 'Trading en Succès',
    'hero.subtitle': 'Plateforme professionnelle de suivi automatisé pour traders MT4/MT5. Synchronisation en temps réel, métriques avancées et journal psychologique pour développer votre discipline.',
    'hero.cta.primary': 'Commencer maintenant',
    'hero.cta.secondary': 'En savoir plus',
    'hero.badge1': 'Métriques Pro',
    'hero.badge2': '100% Sécurisé',
    'hero.badge3': 'Sync Auto',
    'hero.card.totalBalance': 'Balance Totale',
    'hero.card.performance': 'Performance',
    'hero.card.winRate': 'Win Rate',
    'hero.card.trades': 'trades synchronisés automatiquement depuis 3 comptes MT4/MT5',
    'hero.card.tradeInProgress': 'Trade en cours',

    // Stats Section
    'stats.teams': 'Équipes membres',
    'stats.traders': 'Traders actifs',
    'stats.rating': 'Note moyenne',

    // Features Section
    'features.title1': 'Tout ce dont vous avez besoin',
    'features.title2': 'pour progresser',
    'features.subtitle': 'Track Marckete regroupe tous les outils professionnels dont un trader a besoin : synchronisation automatique, analyses poussées, journal psychologique et bien plus encore.',
    'features.dashboard.title': 'Dashboard Complet',
    'features.dashboard.description': 'Vue d\'ensemble en temps réel avec balance totale, P&L global, positions ouvertes et heatmap de performance mensuelle.',
    'features.dashboard.stats': 'Sync toutes les 30s',
    'features.journal.title': 'Journal Psychologique',
    'features.journal.description': 'Documentez vos sessions de trading, évaluez votre état émotionnel et score de discipline pour développer votre mental.',
    'features.journal.stats': 'Discipline tracking',
    'features.analytics.title': 'Analytics Avancées',
    'features.analytics.description': 'Métriques de niveau institutionnel : Profit Factor, Sharpe Ratio, Win Rate, Maximum Drawdown et analyses par symbole.',
    'features.analytics.stats': 'Métriques Pro',
    'features.multiAccount.title': 'Multi-Comptes',
    'features.multiAccount.description': 'Connectez plusieurs comptes MT4/MT5 de différents brokers. Vue consolidée des balances et synchronisation indépendante.',
    'features.multiAccount.stats': 'Comptes illimités',
    'features.sync.title': 'Synchronisation Automatique',
    'features.sync.description': 'Accédez à votre journal de trading professionnel avec toutes les fonctionnalités nécessaires pour analyser vos performances. Interface moderne et intuitive, disponible 24/7 depuis n\'importe quel appareil. Aucune installation requise.',
    'features.sync.point1': 'Support MT4 et MT5',
    'features.sync.point2': 'Tous brokers compatibles',
    'features.sync.point3': 'Détection des doublons',
    'features.sync.lastSync': 'Dernière Synchronisation',
    'features.sync.ago': 'il y a',
    'features.sync.active': 'Synchronisation active',

    // How It Works
    'howItWorks.badge': 'Guide de démarrage',
    'howItWorks.title': 'Comment ça marche ?',
    'howItWorks.subtitle': 'De l\'abonnement à la synchronisation automatique, en 4 étapes simples',
    'howItWorks.step1.title': 'Choisissez et payez votre plan',
    'howItWorks.step1.description': 'Sélectionnez Basic (1 compte), Pro (2 comptes) ou Premium (illimité). Paiement 100% sécurisé par Stripe.',
    'howItWorks.step2.title': 'Confirmation instantanée par email',
    'howItWorks.step2.description': 'Quelques secondes après votre paiement, recevez un email de confirmation. Aucun code à saisir.',
    'howItWorks.step3.title': 'Accédez à votre dashboard',
    'howItWorks.step3.description': 'Connectez-vous avec vos identifiants trackmarkete, puis choisissez le journal lié à votre abonnement depuis votre espace.',
    'howItWorks.step4.title': 'Connectez vos comptes MT4/MT5',
    'howItWorks.step4.description': 'Commencez à utiliser votre journal et profitez de toutes les fonctionnalités pour analyser et améliorer vos performances.',
    'howItWorks.cta': 'Choisir mon plan',

    // Testimonials
    'testimonials.badge': 'Nos clients satisfaits',
    'testimonials.title1': 'Ce que disent',
    'testimonials.title2': 'nos traders',
    'testimonials.subtitle': 'Rejoignez des traders du monde entier qui utilisent Track Marckete pour analyser leurs performances et progresser',
    'testimonials.trader1.name': 'Alexandre D.',
    'testimonials.trader1.role': 'Day Trader Forex',
    'testimonials.trader1.quote': 'Track Marckete a transformé ma façon de trader. La synchronisation automatique MT4 et les métriques avancées m\'ont permis d\'identifier mes erreurs et de passer rentable. Le journal psychologique m\'a aidé à développer ma discipline.',
    'testimonials.trader1.experience': '3 ans d\'expérience',
    'testimonials.trader2.name': 'Sophie M.',
    'testimonials.trader2.role': 'Swing Trader',
    'testimonials.trader2.quote': 'Le journal est parfait pour suivre mes performances. Interface intuitive et analyses détaillées qui m\'aident à identifier mes points forts et axes d\'amélioration. Un outil indispensable !',
    'testimonials.trader2.experience': '2 ans d\'expérience',
    'testimonials.trader3.name': 'Thomas L.',
    'testimonials.trader3.role': 'Trader Professionnel',
    'testimonials.trader3.quote': 'Les métriques pro (Profit Factor, Sharpe Ratio) et la heatmap m\'ont aidé à passer de -5% à +15% en 6 mois. Track Marckete est devenu un outil indispensable dans mon arsenal de trader.',
    'testimonials.trader3.experience': '4 ans d\'expérience',

    // Final CTA
    'finalCTA.title': 'Prêt à améliorer votre trading ?',
    'finalCTA.subtitle': 'Synchronisation automatique MT4/MT5, métriques avancées et journal psychologique pour développer votre discipline',
    'finalCTA.cta.primary': 'Commencer maintenant',
    'finalCTA.cta.secondary': 'Comment ça marche',
    'finalCTA.benefit1': 'Activation instantanée',
    'finalCTA.benefit2': 'Annulation à tout moment',
    'finalCTA.benefit3': 'Tous brokers MT4/MT5',

    // FAQ
    'faq.title': 'Questions Fréquentes',
    'faq.subtitle': 'Tout ce que vous devez savoir sur TrackMarkete',
    'faq.general': 'Général',
    'faq.subscription': 'Abonnement',
    'faq.technical': 'Technique',
    'faq.payment': 'Paiement',
    'faq.general.q1': 'Qu\'est-ce que TrackMarkete ?',
    'faq.general.a1': 'TrackMarkete est une application web qui vous permet de connecter vos comptes de trading MT4/MT5 et d\'analyser automatiquement vos performances. Synchronisation en temps réel, statistiques avancées, journal de notes, le tout dans une interface moderne et intuitive.',
    'faq.general.q2': 'Comment fonctionne la synchronisation ?',
    'faq.general.a2': 'Après avoir souscrit un abonnement, vous liez celui-ci au journal de trading de votre choix depuis votre espace. Chaque journal gère sa propre synchronisation et fonctionnalités.',
    'faq.general.q3': 'Puis-je utiliser MT4 et MT5 en même temps ?',
    'faq.general.a3': 'Oui ! Vous pouvez connecter autant de comptes MT4 et MT5 que votre plan le permet (1 pour Basic, 2 pour Pro, illimité pour Premium). Chaque compte est analysé séparément.',
    'faq.general.q4': 'Mes données sont-elles sécurisées ?',
    'faq.general.a4': 'Oui. Vos données sont hébergées sur Supabase (infrastructure AWS) avec chiffrement en transit (HTTPS) et au repos. Nous utilisons Stripe pour les paiements (certifié PCI-DSS niveau 1). Nous ne stockons jamais vos informations bancaires.',
    'faq.subscription.q1': 'Comment accéder à mon journal ?',
    'faq.subscription.a1': 'Après votre paiement, connectez-vous à votre espace trackmarkete avec vos identifiants habituels, puis rendez-vous dans « Mes journaux » pour choisir le journal lié à votre abonnement. Aucun code à saisir, l\'accès est instantané.',
    'faq.subscription.q2': 'Puis-je changer de plan ?',
    'faq.subscription.a2': 'Oui, à tout moment depuis votre dashboard. Vous pouvez upgrader immédiatement (paiement au prorata). Pour downgrader, le changement prend effet à la fin de votre période en cours.',
    'faq.subscription.q3': 'Que se passe-t-il si j\'annule mon abonnement ?',
    'faq.subscription.a3': 'Vous gardez l\'accès jusqu\'à la fin de votre période payée. Ensuite, votre journal passe en lecture seule : vous pouvez consulter vos données mais plus synchroniser ni ajouter de trades. Si vous vous réabonnez dans les 90 jours, tout est restauré.',
    'faq.subscription.q4': 'Puis-je obtenir un remboursement ?',
    'faq.subscription.a4': 'Nous offrons un remboursement intégral si vous annulez dans les 14 jours suivant votre premier paiement, sans justification. Passé ce délai, aucun remboursement n\'est possible.',
    'faq.technical.q1': 'Comment fonctionne l\'accès aux journaux ?',
    'faq.technical.a1': 'Votre abonnement est lié au journal de votre choix depuis votre espace. Vous accédez ensuite à ce journal avec les mêmes identifiants que sur trackmarkete. Chaque journal est une application web indépendante avec ses propres fonctionnalités.',
    'faq.technical.q2': 'Puis-je changer de journal après activation ?',
    'faq.technical.a2': 'Oui. Vous pouvez changer de journal depuis votre dashboard à tout moment : le changement est immédiat et votre abonnement est relié au nouveau journal dès la confirmation.',
    'faq.payment.q1': 'Quels moyens de paiement acceptez-vous ?',
    'faq.payment.a1': 'Nous acceptons toutes les cartes bancaires (Visa, Mastercard, American Express), Apple Pay, et Google Pay. Les paiements sont traités par Stripe.',
    'faq.payment.q2': 'Les paiements sont-ils sécurisés ?',
    'faq.payment.a2': 'Oui. Nous utilisons Stripe, certifié PCI-DSS niveau 1. Nous ne stockons JAMAIS vos informations bancaires sur nos serveurs.',
    'faq.payment.q3': 'Y a-t-il des frais cachés ?',
    'faq.payment.a3': 'Non. Le prix affiché est le prix final. Aucun frais de setup, aucun frais de transaction, aucune surprise.',
    'faq.noAnswer.title': 'Vous ne trouvez pas votre réponse ?',
    'faq.noAnswer.subtitle': 'Notre équipe est là pour vous aider',
    'faq.noAnswer.cta': 'Nous contacter',

    // Pricing
    'pricing.title': 'Choisissez Votre Formule',
    'pricing.subtitle': 'Sélectionnez la formule parfaite pour vos besoins de trading',
    'pricing.basic.features.1': 'Jusqu\'à 1 compte de trading',
    'pricing.basic.features.2': 'Analyses de base',
    'pricing.basic.features.3': 'Support par email',
    'pricing.basic.features.4': 'Accès application mobile',
    'pricing.pro.features.1': 'Jusqu\'à 5 comptes de trading',
    'pricing.pro.features.2': 'Analyses avancées',
    'pricing.pro.features.3': 'Support prioritaire par email',
    'pricing.pro.features.4': 'Accès application mobile',
    'pricing.pro.features.5': 'Alertes personnalisées',
    'pricing.pro.features.6': 'Export de données',
    'pricing.premium.features.1': 'Comptes de trading illimités',
    'pricing.premium.features.2': 'Analyses premium',
    'pricing.premium.features.3': 'Support téléphone & email',
    'pricing.premium.features.4': 'Accès application mobile',
    'pricing.premium.features.5': 'Alertes personnalisées',
    'pricing.premium.features.6': 'Export de données',
    'pricing.premium.features.7': 'Accès API',
    'pricing.premium.features.8': 'Gestionnaire de compte dédié',

    // Shop
    'shop.title': 'Nos Journaux de Trading',
    'shop.subtitle': 'Choisissez le journal qui correspond à votre style de trading',
    'shop.loading': 'Chargement...',
    'shop.noJournals': 'Aucun journal disponible pour le moment',
    'shop.feature1': 'Interface inspirée des terminaux professionnels',
    'shop.feature2': 'Analyses détaillées de vos trades',
    'shop.feature3': 'Accès illimité avec votre abonnement',
    'shop.cta': 'Commencer maintenant',
    'shop.visitJournal': 'Visiter le journal',
    'shop.comingSoon': 'Bientôt disponible',
    'shop.howItWorks.title': 'Comment ça marche?',
    'shop.howItWorks.step1.title': 'Choisissez votre plan',
    'shop.howItWorks.step1.description': 'Sélectionnez le plan qui correspond à vos besoins',
    'shop.howItWorks.step2.title': 'Liez votre journal',
    'shop.howItWorks.step2.description': 'Sélectionnez le journal lié à votre abonnement depuis votre espace',
    'shop.howItWorks.step3.title': 'Connectez-vous et tradez',
    'shop.howItWorks.step3.description': 'Accédez au journal avec vos identifiants trackmarkete et commencez à trader',

    // Footer
    'footer.description': 'Analysez vos performances de trading MT4/MT5 en temps réel. Synchronisation automatique, analyses avancées, journal détaillé.',
    'footer.product': 'Produit',
    'footer.company': 'Entreprise',
    'footer.legal': 'Légal',
    'footer.product.features': 'Accueil',
    'footer.product.pricing': 'Tarifs',
    'footer.product.howItWorks': 'Comment ça marche',
    'footer.product.faq': 'FAQ',
    'footer.company.about': 'À propos',
    'footer.company.affiliate': 'Affiliation',
    'footer.company.contact': 'Contact',
    'footer.legal.terms': 'Conditions générales',
    'footer.legal.privacy': 'Politique de confidentialité',
    'footer.legal.cookies': 'Politique des cookies',
    'footer.copyright': 'Tous droits réservés.',
  },
  en: {
    // Navigation
    'nav.features': 'Home',
    'nav.shop': 'Shop',
    'nav.pricing': 'Pricing',
    'nav.howItWorks': 'How it Works',
    'nav.faq': 'FAQ',
    'nav.affiliate': 'Affiliate',
    'nav.login': 'Login',
    'nav.signup': 'Sign Up',
    'nav.myAccount': 'My Account',
    'nav.mainLabel': 'Main navigation',
    'nav.skipToContent': 'Skip to content',
    'nav.openMenu': 'Open menu',
    'nav.closeMenu': 'Close menu',

    // Hero Section
    'hero.title1': 'Transform Your',
    'hero.title2': 'Trading into Success',
    'hero.subtitle': 'Professional automated tracking platform for MT4/MT5 traders. Real-time synchronization, advanced metrics and psychological journal to develop your discipline.',
    'hero.cta.primary': 'Get Started Now',
    'hero.cta.secondary': 'Learn More',
    'hero.badge1': 'Pro Metrics',
    'hero.badge2': '100% Secure',
    'hero.badge3': 'Auto Sync',
    'hero.card.totalBalance': 'Total Balance',
    'hero.card.performance': 'Performance',
    'hero.card.winRate': 'Win Rate',
    'hero.card.trades': 'trades automatically synced from 3 MT4/MT5 accounts',
    'hero.card.tradeInProgress': 'Trade in Progress',

    // Stats Section
    'stats.teams': 'Member teams',
    'stats.traders': 'Active traders',
    'stats.rating': 'Average rating',

    // Features Section
    'features.title1': 'Everything you need',
    'features.title2': 'to improve',
    'features.subtitle': 'Track Marckete brings together all the professional tools a trader needs: automatic synchronization, advanced analytics, psychological journal and much more.',
    'features.dashboard.title': 'Complete Dashboard',
    'features.dashboard.description': 'Real-time overview with total balance, global P&L, open positions and monthly performance heatmap.',
    'features.dashboard.stats': 'Sync every 30s',
    'features.journal.title': 'Psychological Journal',
    'features.journal.description': 'Document your trading sessions, assess your emotional state and discipline score to develop your mental game.',
    'features.journal.stats': 'Discipline tracking',
    'features.analytics.title': 'Advanced Analytics',
    'features.analytics.description': 'Institutional-level metrics: Profit Factor, Sharpe Ratio, Win Rate, Maximum Drawdown and symbol analysis.',
    'features.analytics.stats': 'Pro Metrics',
    'features.multiAccount.title': 'Multi-Account',
    'features.multiAccount.description': 'Connect multiple MT4/MT5 accounts from different brokers. Consolidated balance view and independent synchronization.',
    'features.multiAccount.stats': 'Unlimited accounts',
    'features.sync.title': 'Automatic Synchronization',
    'features.sync.description': 'Access your professional trading journal with all the features you need to analyze your performance. Modern and intuitive interface, available 24/7 from any device. No installation required.',
    'features.sync.point1': 'MT4 and MT5 support',
    'features.sync.point2': 'All brokers compatible',
    'features.sync.point3': 'Duplicate detection',
    'features.sync.lastSync': 'Last Synchronization',
    'features.sync.ago': 'ago',
    'features.sync.active': 'Synchronization active',

    // How It Works
    'howItWorks.badge': 'Getting Started Guide',
    'howItWorks.title': 'How does it work?',
    'howItWorks.subtitle': 'From subscription to automatic synchronization, in 4 simple steps',
    'howItWorks.step1.title': 'Choose and pay for your plan',
    'howItWorks.step1.description': 'Select Basic (1 account), Pro (2 accounts) or Premium (unlimited). 100% secure payment via Stripe.',
    'howItWorks.step2.title': 'Instant confirmation by email',
    'howItWorks.step2.description': 'A few seconds after your payment, you receive a confirmation email. No code to enter.',
    'howItWorks.step3.title': 'Access your dashboard',
    'howItWorks.step3.description': 'Log in with your trackmarkete credentials, then pick the journal linked to your subscription from your dashboard.',
    'howItWorks.step4.title': 'Connect your MT4/MT5 accounts',
    'howItWorks.step4.description': 'Start using your journal and enjoy all the features to analyze and improve your performance.',
    'howItWorks.cta': 'Choose My Plan',

    // Testimonials
    'testimonials.badge': 'Our Satisfied Customers',
    'testimonials.title1': 'What our',
    'testimonials.title2': 'traders say',
    'testimonials.subtitle': 'Join traders from around the world who use Track Marckete to analyze their performance and improve',
    'testimonials.trader1.name': 'Alexandre D.',
    'testimonials.trader1.role': 'Forex Day Trader',
    'testimonials.trader1.quote': 'Track Marckete transformed my trading approach. The automatic MT4 sync and advanced metrics helped me identify my mistakes and become profitable. The psychological journal helped develop my discipline.',
    'testimonials.trader1.experience': '3 years of experience',
    'testimonials.trader2.name': 'Sophie M.',
    'testimonials.trader2.role': 'Swing Trader',
    'testimonials.trader2.quote': 'The journal is perfect for tracking my performance. Intuitive interface and detailed analytics that help me identify my strengths and areas for improvement. An essential tool!',
    'testimonials.trader2.experience': '2 years of experience',
    'testimonials.trader3.name': 'Thomas L.',
    'testimonials.trader3.role': 'Professional Trader',
    'testimonials.trader3.quote': 'The pro metrics (Profit Factor, Sharpe Ratio) and heatmap helped me go from -5% to +15% in 6 months. Track Marckete has become an essential tool in my trading arsenal.',
    'testimonials.trader3.experience': '4 years of experience',

    // Final CTA
    'finalCTA.title': 'Ready to improve your trading?',
    'finalCTA.subtitle': 'Automatic MT4/MT5 synchronization, advanced metrics and psychological journal to develop your discipline',
    'finalCTA.cta.primary': 'Get Started Now',
    'finalCTA.cta.secondary': 'How it Works',
    'finalCTA.benefit1': 'Instant activation',
    'finalCTA.benefit2': 'Cancel anytime',
    'finalCTA.benefit3': 'All MT4/MT5 brokers',

    // FAQ
    'faq.title': 'Frequently Asked Questions',
    'faq.subtitle': 'Everything you need to know about TrackMarkete',
    'faq.general': 'General',
    'faq.subscription': 'Subscription',
    'faq.technical': 'Technical',
    'faq.payment': 'Payment',
    'faq.general.q1': 'What is TrackMarkete?',
    'faq.general.a1': 'TrackMarkete is a web application that allows you to connect your MT4/MT5 trading accounts and automatically analyze your performance. Real-time synchronization, advanced statistics, trading journal, all in a modern and intuitive interface.',
    'faq.general.q2': 'How does synchronization work?',
    'faq.general.a2': 'After subscribing, you link your subscription to the trading journal of your choice from your dashboard. Each journal manages its own synchronization and features.',
    'faq.general.q3': 'Can I use MT4 and MT5 at the same time?',
    'faq.general.a3': 'Yes! You can connect as many MT4 and MT5 accounts as your plan allows (1 for Basic, 2 for Pro, unlimited for Premium). Each account is analyzed separately.',
    'faq.general.q4': 'Is my data secure?',
    'faq.general.a4': 'Yes. Your data is hosted on Supabase (AWS infrastructure) with encryption in transit (HTTPS) and at rest. We use Stripe for payments (PCI-DSS Level 1 certified). We never store your banking information.',
    'faq.subscription.q1': 'How do I access my journal?',
    'faq.subscription.a1': 'After your payment, log in to your trackmarkete space with your usual credentials, then go to "My journals" to pick the journal linked to your subscription. No code to enter — access is instant.',
    'faq.subscription.q2': 'Can I change plans?',
    'faq.subscription.a2': 'Yes, at any time from your dashboard. You can upgrade immediately (prorated payment). To downgrade, the change takes effect at the end of your current period.',
    'faq.subscription.q3': 'What happens if I cancel my subscription?',
    'faq.subscription.a3': 'You keep access until the end of your paid period. Then, your journal becomes read-only: you can view your data but no longer sync or add trades. If you resubscribe within 90 days, everything is restored.',
    'faq.subscription.q4': 'Can I get a refund?',
    'faq.subscription.a4': 'We offer a full refund if you cancel within 14 days of your first payment, no questions asked. After that period, no refunds are possible.',
    'faq.technical.q1': 'How does journal access work?',
    'faq.technical.a1': 'Your subscription is linked to the journal of your choice from your dashboard. You then access that journal with the same credentials as on trackmarkete. Each journal is an independent web application with its own features.',
    'faq.technical.q2': 'Can I change journals after activation?',
    'faq.technical.a2': 'Yes. You can change journals from your dashboard at any time: the change is instant and your subscription is linked to the new journal as soon as you confirm.',
    'faq.payment.q1': 'What payment methods do you accept?',
    'faq.payment.a1': 'We accept all credit cards (Visa, Mastercard, American Express), Apple Pay, and Google Pay. Payments are processed by Stripe.',
    'faq.payment.q2': 'Are payments secure?',
    'faq.payment.a2': 'Yes. We use Stripe, PCI-DSS Level 1 certified. We NEVER store your banking information on our servers.',
    'faq.payment.q3': 'Are there any hidden fees?',
    'faq.payment.a3': 'No. The displayed price is the final price. No setup fees, no transaction fees, no surprises.',
    'faq.noAnswer.title': 'Can\'t find your answer?',
    'faq.noAnswer.subtitle': 'Our team is here to help',
    'faq.noAnswer.cta': 'Contact us',

    // Pricing
    'pricing.title': 'Choose Your Plan',
    'pricing.subtitle': 'Select the perfect plan for your trading needs',
    'pricing.basic.features.1': 'Up to 1 trading account',
    'pricing.basic.features.2': 'Basic analytics',
    'pricing.basic.features.3': 'Email support',
    'pricing.basic.features.4': 'Mobile app access',
    'pricing.pro.features.1': 'Up to 5 trading accounts',
    'pricing.pro.features.2': 'Advanced analytics',
    'pricing.pro.features.3': 'Priority email support',
    'pricing.pro.features.4': 'Mobile app access',
    'pricing.pro.features.5': 'Custom alerts',
    'pricing.pro.features.6': 'Export data',
    'pricing.premium.features.1': 'Unlimited trading accounts',
    'pricing.premium.features.2': 'Premium analytics',
    'pricing.premium.features.3': 'Phone & email support',
    'pricing.premium.features.4': 'Mobile app access',
    'pricing.premium.features.5': 'Custom alerts',
    'pricing.premium.features.6': 'Export data',
    'pricing.premium.features.7': 'API access',
    'pricing.premium.features.8': 'Dedicated account manager',

    // Shop
    'shop.title': 'Our Trading Journals',
    'shop.subtitle': 'Choose the journal that matches your trading style',
    'shop.loading': 'Loading...',
    'shop.noJournals': 'No journals available at the moment',
    'shop.feature1': 'Interface inspired by professional terminals',
    'shop.feature2': 'Detailed analysis of your trades',
    'shop.feature3': 'Unlimited access with your subscription',
    'shop.cta': 'Get Started Now',
    'shop.visitJournal': 'Visit journal',
    'shop.comingSoon': 'Coming soon',
    'shop.howItWorks.title': 'How does it work?',
    'shop.howItWorks.step1.title': 'Choose your plan',
    'shop.howItWorks.step1.description': 'Select the plan that fits your needs',
    'shop.howItWorks.step2.title': 'Link your journal',
    'shop.howItWorks.step2.description': 'Pick the journal linked to your subscription from your dashboard',
    'shop.howItWorks.step3.title': 'Log in and trade',
    'shop.howItWorks.step3.description': 'Access the journal with your trackmarkete credentials and start trading',

    // MT Accounts & Journal Sync
    'mtAccounts.title': 'MT Accounts',
    'mtAccounts.subtitle': 'Connect your MetaTrader accounts to sync trades automatically',
    'mtAccounts.addAccount': 'Add MT Account',
    'mtAccounts.noAccounts': 'No MT Accounts',
    'mtAccounts.noAccountsDescription': 'Connect your first MetaTrader account to start syncing trades',
    'mtAccounts.addFirstAccount': 'Add Your First Account',
    'mtAccounts.balance': 'Balance',
    'mtAccounts.equity': 'Equity',
    'mtAccounts.lastMTSync': 'Last MT Sync',
    'mtAccounts.journalSync': 'Journal Sync',
    'mtAccounts.syncedJournal': 'Synced Journal',
    'mtAccounts.refresh': 'Refresh',
    'mtAccounts.syncTrades': 'Sync Trades',
    'mtAccounts.linkJournal': 'Link Journal',
    'mtAccounts.changeJournal': 'Change Journal',
    'mtAccounts.delete': 'Delete',
    'mtAccounts.connected': 'Connected',
    'mtAccounts.deploying': 'Deploying',
    'mtAccounts.needsConfiguration': 'Needs Configuration',
    'mtAccounts.notSynced': 'Not Synced',
    'mtAccounts.synced': 'Synced',
    'mtAccounts.pending': 'Pending',
    'mtAccounts.error': 'Error',
    'mtAccounts.none': 'None',
    'mtAccounts.unknown': 'Unknown',
    'mtAccounts.never': 'Never',
    'mtAccounts.syncing': 'Syncing...',
    'mtAccounts.journalSyncError': 'Journal Sync Error',
    'mtAccounts.lastSyncedTo': 'Last synced to',
    'mtAccounts.on': 'on',

    // Journal Sync Modal
    'journalSync.selectTitle': 'Select Journal to Sync',
    'journalSync.selectDescription': 'Choose the journal where you want to automatically sync your trades. You\'ll be able to access your trading data on the selected journal using your email.',
    'journalSync.continue': 'Continue',
    'journalSync.cancel': 'Cancel',
    'journalSync.confirmTitle': 'Confirm Journal Synchronization',
    'journalSync.confirmQuestion': 'Are you sure you want to sync with',
    'journalSync.confirmDescription': 'This will automatically send all your MT trades to the selected journal.',
    'journalSync.journal': 'Journal',
    'journalSync.syncEmail': 'Sync Email',
    'journalSync.importantInfo': 'Important Information',
    'journalSync.info1': 'A journal account will be created with your email:',
    'journalSync.info2': 'You can log in to the journal using this email',
    'journalSync.info3': 'All your MT trades will be automatically synced',
    'journalSync.info4': 'You can change or disconnect the journal at any time',
    'journalSync.confirmButton': 'Yes, Start Sync',
    'journalSync.selected': 'Selected',
    'journalSync.visitJournal': 'Visit Journal',
    'journalSync.noJournals': 'No journals available at the moment.',
    'journalSync.errorLoading': 'Error loading journals:',

    // Footer
    'footer.description': 'Analyze your MT4/MT5 trading performance in real-time. Automatic synchronization, advanced analytics, detailed journal.',
    'footer.product': 'Product',
    'footer.company': 'Company',
    'footer.legal': 'Legal',
    'footer.product.features': 'Home',
    'footer.product.pricing': 'Pricing',
    'footer.product.howItWorks': 'How it Works',
    'footer.product.faq': 'FAQ',
    'footer.company.about': 'About',
    'footer.company.affiliate': 'Affiliate',
    'footer.company.contact': 'Contact',
    'footer.legal.terms': 'Terms of Service',
    'footer.legal.privacy': 'Privacy Policy',
    'footer.legal.cookies': 'Cookie Policy',
    'footer.copyright': 'All rights reserved.',
  },
}
